import { prettyFloat } from 'webui/utils/number';
import { OpenThermVariableName } from 'openTherm';
import { AnalogInput, get_z3k_object_state, RadioSensor, RadioSensor433, } from 'z3k-config';
import { createSelector } from '@reduxjs/toolkit';
import { Z3kSecondRoutes } from 'z3k-settings/routes/type';
const getAnalogInputState = createSelector((z3k_config, z3k_state, { id }) => AnalogInput.get.byId(z3k_config, id), (z3k_config, z3k_state, { id }) => get_z3k_object_state(z3k_state, id) ??
    {}, (z3k_config, z3k_state, { type }) => type && AnalogInput.booleanSensorsTypes.includes(type), (sensor, state, is_boolean) => {
    const alarm = AnalogInput.isTriggered(state);
    const is_worker = sensor && AnalogInput.isWorkingSensor(sensor);
    const untracked_alarm = AnalogInput.isWorked(state);
    const no_connection = AnalogInput.isDamageWire(state);
    const human_value = Object.keys(state).length > 0 && sensor
        ? AnalogInput.getValueHuman(sensor, state)
        : null;
    const value = is_boolean ? null : Number(human_value);
    return { alarm, is_worker, untracked_alarm, no_connection, value };
});
function get_radio_rf(state) {
    if (state) {
        if ('battery' in state && 'rssi' in state) {
            return { bat_v: state.battery, dbm: state.rssi };
        }
    }
    return undefined;
}
const getRadioSensorState = createSelector((z3k_config, z3k_state, { id }) => get_z3k_object_state(z3k_state, id) ??
    {}, (z3k_config, z3k_state, { type }) => type === RadioSensor.Type.HUMIDITY, (state, is_humidity_sensor) => {
    const alarm = RadioSensor.isActive(state);
    const no_connection = RadioSensor.isNoConnect(state);
    const untracked_alarm = RadioSensor.isTempTriggered(state);
    const value = is_humidity_sensor && state ? state.humidity : null;
    const rf_indicators = get_radio_rf(state);
    const no_valid = RadioSensor.isNoValidFlag(state);
    return { alarm, untracked_alarm, no_connection, value, rf_indicators, no_valid };
});
const getRadioSensor433State = createSelector((z3k_config, z3k_state, { id }) => RadioSensor433.get.byId(z3k_config, id), (z3k_config, z3k_state, { id }) => get_z3k_object_state(z3k_state, id) ??
    {}, (sensor, state) => {
    const alarm = RadioSensor433.isTriggered(state);
    const is_worker = sensor && RadioSensor433.isWorkingSensor(sensor);
    const no_connection = false;
    const untracked_alarm = false;
    return {
        alarm,
        is_worker,
        untracked_alarm,
        no_connection,
        value: null,
        rf_indicators: { is_433: true },
    };
});
const getBoilerAdapterSensor = createSelector((z3k_config, z3k_state, { open_therm }) => open_therm != null
    ? get_z3k_object_state(z3k_state, open_therm.boiler_adapter_id)?.ot ?? null
    : null, (z3k_config, z3k_state, sensor_config) => sensor_config, (ot_state, sensor_config) => {
    const { open_therm, limits: config_limits } = sensor_config;
    const max_modulation = ot_state?.[OpenThermVariableName.mrml] ?? 100;
    const limits = {
        high: open_therm?.ot_name == OpenThermVariableName.rml
            ? max_modulation
            : open_therm?.ot_name == OpenThermVariableName.fr
                ? 35
                : 3,
        low: config_limits?.low !== undefined ? config_limits.low : null,
    };
    const value = open_therm
        ? Number(prettyFloat(ot_state?.[open_therm.ot_name], 1))
        : null;
    const alarm = false;
    const no_connection = false;
    return { alarm, limits, no_connection, value };
});
export const getZ3KSensorState = (z3k_config, z3k_state, sensor_config, sensor_key) => {
    if (sensor_key === Z3kSecondRoutes.analog_inputs) {
        return getAnalogInputState(z3k_config, z3k_state, sensor_config);
    }
    if (sensor_key === Z3kSecondRoutes.radiosensor868) {
        return getRadioSensorState(z3k_config, z3k_state, sensor_config);
    }
    if (sensor_key === Z3kSecondRoutes.radiosensor433) {
        return getRadioSensor433State(z3k_config, z3k_state, sensor_config);
    }
    return getBoilerAdapterSensor(z3k_config, z3k_state, sensor_config);
};
